import { Component, Inject, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { CombosService } from '../../../services/combos.service';
import { ValidateService } from '../../../services/validate.service';
import { Combo } from '../../../models/combo';
import { SpinnerService } from '../../../services/spinner.service';
import { SnackbarService } from '../../../services/snackbar.service';
import Swal from 'sweetalert2';
import {
  PuntoRecogidaControllerService,
  PtoRecogidaPayloadDTO,
} from 'api-rest';

@Component({
  selector: 'app-collection-points-preliminary',
  templateUrl: './collection-points-preliminary.component.html',
  styleUrls: ['./collection-points-preliminary.component.scss'],
})
export class CollectionPointsPreliminaryComponent implements OnInit {
  dataForm: FormGroup;
  tiposDocumento: Combo[] = [];
  pageNumber: number = 0;
  pageSize: number = 100;

  paisesEndpoint = this.environment.urlBackCore + 'api/v1/core/countries';
  paisesSortValue = 'iso';

  flagDisabledForm: boolean = false;
  updateList: boolean = false;
  paisPrefijo!: any;

  constructor(
    @Inject('environment') private environment: any,
    private formBuilder: FormBuilder,
    private validateSrv: ValidateService,
    private dialogRef: MatDialogRef<CollectionPointsPreliminaryComponent>,
    private comboSrv: CombosService,
    public spinnerSrv: SpinnerService,
    private snackBarSrv: SnackbarService,
    private puntoRecogidaControllerService: PuntoRecogidaControllerService
  ) {
    this.dataForm = this.formBuilder.group({
      razonSocial: [
        { value: null, disabled: false },
        { validators: Validators.compose([Validators.required, Validators.maxLength(255)]) },
      ],
      denominacion: [
        { value: null, disabled: false },
        { validators: Validators.compose([Validators.required, Validators.maxLength(255)]) },
      ],
      nimaPtoRecogida: [
        { value: null, disabled: false },
        {
          validators: Validators.compose([
            Validators.required,
            Validators.pattern(this.validateSrv.nimaPattern),
            Validators.maxLength(10)
          ]),
        },
      ],
      nimaOperador: [
        { value: null, disabled: false },
        {
          validators: Validators.compose([
            Validators.pattern(this.validateSrv.nimaPattern),
            Validators.maxLength(10)
          ]),
        },
      ],
      documentType: [
        { value: null, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],
      documentNumber: [
        { value: null, disabled: false },
        {
          validators: Validators.compose([
            Validators.required,
            Validators.pattern(this.validateSrv.documentNumber),
            Validators.maxLength(15)
          ]),
        },
      ],

      nombre: [
        { value: null, disabled: false },
        { validators: Validators.compose([Validators.required, Validators.maxLength(50)]) },
      ],
      apellido1: [
        { value: null, disabled: false },
        { validators: Validators.compose([Validators.required, Validators.maxLength(50)]) },
      ],
      apellido2: [{ value: null, disabled: false },
        {validators: Validators.compose([Validators.maxLength(50)])}
      ],
      documentTypeContact: [
        { value: null, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],
      documentNumberContact: [
        { value: null, disabled: false },
        {
          validators: Validators.compose([
            Validators.required,
            Validators.pattern(this.validateSrv.documentNumber),
            Validators.maxLength(15)
          ]),
        },
      ],

      email: [
        { value: null, disabled: false },
        {
          validators: Validators.compose([
            Validators.required,
            Validators.pattern(this.validateSrv.emailPattern),
            Validators.maxLength(100)
          ]),
        },
      ],
      tlfType: [
        { value: null, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],
      countryCode: [
        { value: null, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],
      tlfNumber: [
        { value: null, disabled: false },
        {
          validators: Validators.compose([
            Validators.required,
            this.telefonoValidator.bind(this),
            Validators.maxLength(15)
          ]),
        },
      ],
    });
  }

  ngOnInit(): void {
    this.tiposDocumento = this.comboSrv.getTiposDocumentoIdentidad();

    this.dataForm.get('tlfType')?.valueChanges.subscribe(() => {
      this.dataForm.get('tlfNumber')?.updateValueAndValidity();
    });

    this.dataForm.get('countryCode')?.valueChanges.subscribe(() => {
      this.dataForm.get('tlfNumber')?.updateValueAndValidity();
    });
  }

  telefonoValidator(control: AbstractControl): { [key: string]: any } | null {
    const tipoTelefono = this.dataForm?.get('tlfType')?.value;
    const prefijoPais = this.dataForm?.get('countryCode')?.value;

    const phonePattern =
      /^(\+?\d{1,3})?[-. (]?(\d{1,4})[-. )]?(\d{1,4})[-. ]?(\d{1,4})[-. ]?(\d{1,9})$/;
    const isGeneralValid = phonePattern.test(control.value);

    if (!isGeneralValid) {
      return { invalidPhoneFormat: true };
    }

    if (
      prefijoPais?.prefijo == '34' ||
      (typeof prefijoPais === 'string' && prefijoPais?.toUpperCase() == '34 (ESPAÑA)')
    ) {
      if (tipoTelefono === 'FIJO') {
        const valid = /^[89][0-9]{8}$/.test(control.value);
        return valid ? null : { invalidTelefonoFijo: true };
      } else if (tipoTelefono === 'MOVIL') {
        const valid = /^[67][0-9]{8}$/.test(control.value);
        return valid ? null : { invalidTelefonoMovil: true };
      }
    }

    return null;
  }

  tipoDocumentoSel(idTipoDoc: string) {
    this.dataForm.get('documentNumber')?.clearValidators();
    if (idTipoDoc === 'NIF') {
      this.dataForm
        .get('documentNumber')
        ?.setValidators([
          Validators.required,
          Validators.pattern(this.validateSrv.nifPattern),
        ]);
    } else if (idTipoDoc === 'DNI') {
      this.dataForm
        .get('documentNumber')
        ?.setValidators([
          Validators.required,
          Validators.pattern(this.validateSrv.dniPattern),
        ]);
    } else if (idTipoDoc === 'NIE') {
      this.dataForm
        .get('documentNumber')
        ?.setValidators([
          Validators.required,
          Validators.pattern(this.validateSrv.niePattern),
        ]);
    }
    this.dataForm.get('documentNumber')?.updateValueAndValidity();
    this.dataForm.get('documentNumber')?.markAsTouched();
  }

  tipoDocumentoSelContact(idTipoDoc: string) {
    this.dataForm.get('documentNumberContact')?.clearValidators();
    if (idTipoDoc === 'NIF') {
      this.dataForm
        .get('documentNumberContact')
        ?.setValidators([
          Validators.required,
          Validators.pattern(this.validateSrv.nifPattern),
        ]);
    } else if (idTipoDoc === 'DNI') {
      this.dataForm
        .get('documentNumberContact')
        ?.setValidators([
          Validators.required,
          Validators.pattern(this.validateSrv.dniPattern),
        ]);
    } else if (idTipoDoc === 'NIE') {
      this.dataForm
        .get('documentNumberContact')
        ?.setValidators([
          Validators.required,
          Validators.pattern(this.validateSrv.niePattern),
        ]);
    }
    this.dataForm.get('documentNumberContact')?.updateValueAndValidity();
    this.dataForm.get('documentNumberContact')?.markAsTouched();
  }

  public filterList(data: any) {}

  getFormControl(selectForm: any): FormControl {
    switch (selectForm) {
      case 'countryCode': {
        return this.dataForm.get('countryCode') as FormControl;
        break;
      }
      default: {
        return this.dataForm.get('') as FormControl;
        break;
      }
    }
  }

  saveData() {
    this.dataForm.markAllAsTouched();
    this.dataForm.updateValueAndValidity();

    if (this.dataForm.valid) {
      const objPuntosRecogidaFilter: PtoRecogidaPayloadDTO = {
        razonSocial: this.dataForm.get('razonSocial')?.value ? this.dataForm.get('razonSocial')?.value.trim() : undefined,
        denominacion: this.dataForm.get('denominacion')?.value ? this.dataForm.get('denominacion')?.value.trim() : undefined,
        nimaOperador: this.dataForm.get('nimaOperador')?.value,
        nimaPtoRecogida: this.dataForm.get('nimaPtoRecogida')?.value,
        tipoDocumento: this.dataForm.get('documentType')?.value,
        codigoDocumento: this.dataForm.get('documentNumber')?.value,
        contacto: {
          nombre: this.dataForm.get('nombre')?.value ? this.dataForm.get('nombre')?.value.trim() : '',
          apellido1: this.dataForm.get('apellido1')?.value ? this.dataForm.get('apellido1')?.value.trim() : '',
          apellido2: this.dataForm.get('apellido2')?.value ? this.dataForm.get('apellido2')?.value.trim() : '',
          email: this.dataForm.get('email')?.value ? this.dataForm.get('email')?.value.trim() : null,
          tipo_documento: this.dataForm.get('documentTypeContact')?.value,
          codigo_documento: this.dataForm.get('documentNumberContact')?.value ? this.dataForm.get('documentNumberContact')?.value.trim() : '',
          tipoTelefono: this.dataForm.get('tlfType')?.value,
          numeroTelefono: this.dataForm.get('tlfNumber')?.value ? this.dataForm.get('tlfNumber')?.value.trim() : '',
          codigoPais: this.paisPrefijo
        },
      };

      this.performSave(objPuntosRecogidaFilter);
    } else {
      this.snackBarSrv.showSnackBar(
        'Debe completar los campos obligatorios',
        'error'
      );
    }
  }

  selPaginatorHasError(controlName: string) {
    if (
      (this.dataForm.controls[controlName]?.touched ||
        this.dataForm.controls[controlName]?.dirty) &&
      this.dataForm.controls[controlName]?.errors
    ) {
      return true;
    } else {
      return false;
    }
  }

  performSave(data: PtoRecogidaPayloadDTO) {
    this.spinnerSrv.loadingShow();
    this.puntoRecogidaControllerService.createPtoRecogida(data).subscribe({
      next: (value: any) => {
        this.spinnerSrv.loadingHide();
        this.dialogRef.close(true);
        this.snackBarSrv.showSnackBar(
          'Alta preliminar realizada correctamente',
          'success'
        );
      },
      error: (error: any) => {
        this.spinnerSrv.loadingHide();
        let errorArgs =error.error?.arguments[0].split(" : ")[1];
        errorArgs = errorArgs.replace(/\\"/g, '"').replace(/^"/, "").replace(/"$/, ""); // Limpiar comillas escapadas y eliminar las externas
        let parsedArgument = JSON.parse(errorArgs);
        let mensajeError = `${error.error?.cause}. ${parsedArgument?.detail}`;
        this.snackBarSrv.showSnackBar(mensajeError, 'error');
      },
    });
  }

  controlHasError(controlName: string, errorName: string) {
    return (
      this.dataForm.controls[controlName].hasError(errorName) &&
      this.dataForm.controls[controlName].touched
    );
  }

  controlHasErrorSelect(controlName: string) {
    if (
      (this.dataForm.controls[controlName]?.touched ||
        this.dataForm.controls[controlName]?.dirty) &&
      this.dataForm.controls[controlName]?.errors
    ) {
      return true;
    } else {
      return false;
    }
  }

  public rightHolder(controlName: string) {
    let cl2 = '';
    if (
      (this.dataForm.controls[controlName]?.touched ||
        this.dataForm.controls[controlName]?.dirty) &&
      this.dataForm.controls[controlName]?.errors
    ) {
      cl2 = 'error-focus-input';
    } else {
      cl2 = 'success-focus-input';
    }
    return `${cl2}`;
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  confirmacion(titulo: string, callBack: Function): void {
    Swal.fire({
      text: titulo,
      icon: 'question',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Sí',
      denyButtonText: 'No',
      allowOutsideClick: false,
    }).then((result: any) => {
      if (result.isConfirmed) {
        callBack();
      }
    });
  }

    selectedModel(selectForm: any, event:any) {
    switch (selectForm) {
      case 'countryCode': {
        let prefijo = this.dataForm.get('countryCode')?.value;
        if (typeof prefijo === 'string') {
          this.paisPrefijo = event;
        } else {
          this.paisPrefijo = this.dataForm.controls['countryCode']?.value;
        }
        break;
      }
      default: {
        break;
      }
    }
  }
  
    onInput(controlName: string, event: any) {
    const control = this.dataForm.get(controlName)
    const input = event.target as HTMLInputElement;
    control?.markAsTouched();
    control?.markAsDirty();
  }
}
